import "./mask.css";
import { Mask } from './mask';
export default Mask;